import { Subject } from 'rxjs'

function funds2CartSubject() {
  const shoppingCartSubject = new Subject()

  return {
    funds2CartSubject: shoppingCartSubject,
    funds2CartTrigger: (items) => {
      shoppingCartSubject.next(items)
    }
  }
}

function cart2FundsSubject() {
  const shoppingCartSubject = new Subject()

  return {
    cart2FundSubject: shoppingCartSubject,
    cart2FundTrigger: (fundItems) => {
      shoppingCartSubject.next(fundItems)
    }
  }
}

export { funds2CartSubject, cart2FundsSubject }
